module.exports = __webpack_public_path__ + "img/서비스AgeTech.b1b1e2fc.png";